// Working-day maths for the scheduled workflows (drilling, loops, small jobs). The server
// has the same rule in api.js (wfsEnd) — a length is counted in Monday–Friday days, the
// start counts as day one, and a start on a weekend counts from the Monday.
const at = s => new Date(`${s}T12:00:00`);
const isWork = d => d.getDay() !== 0 && d.getDay() !== 6;
const ymd = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export function workdayEnd(start, days) {
  if (!start || !(days > 0)) return null;
  const d = at(start);
  if (isNaN(d)) return null;
  while (!isWork(d)) d.setDate(d.getDate() + 1);
  // Half days round UP to the day they finish on (same as the server).
  for (let left = Math.ceil(days) - 1; left > 0;) { d.setDate(d.getDate() + 1); if (isWork(d)) left--; }
  return ymd(d);
}

const md = s => at(s).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });

// What a card's date pill says: "Oct 1" with no length, "Oct 1 → Oct 7 · 5d" with one.
export function spanLabel(start, days, empty = 'Set date') {
  if (!start) return empty;
  const end = days > 1 ? workdayEnd(start, days) : null;
  return end && end !== start ? `${md(start)} → ${md(end)} · ${days}d` : md(start);
}
